import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import { t } from 'i18next';

import { PseudoLink } from '~components/Helpers/PseudoLink';

interface ClearFiltersHintProps {
  dataTestId?: string;
  onClearFilters?: () => void;
}

export function ClearFiltersLink({ dataTestId, onClearFilters }: ClearFiltersHintProps) {
  const theme = useTheme();

  return (
    <PseudoLink
      title={t('common.no_results_with_filters_clear')}
      action={() => onClearFilters?.()}
      dataTestId={dataTestId}
      linkColor={theme.brandV2.colors.treadBlue}
      sx={{ display: 'inline-block' }}
    />
  );
}

export function ClearFiltersHint({ dataTestId, onClearFilters }: ClearFiltersHintProps) {
  return (
    <Box data-test-id={dataTestId} sx={{ py: 1, textAlign: 'center' }}>
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        {t('common.no_results_with_filters')}
      </Typography>
      <ClearFiltersLink onClearFilters={onClearFilters} />
    </Box>
  );
}
